import { render, staticRenderFns } from "./BaseMetricsSum.vue?vue&type=template&id=2ec4d266&scoped=true"
import script from "./BaseMetricsSum.vue?vue&type=script&lang=js"
export * from "./BaseMetricsSum.vue?vue&type=script&lang=js"
import style0 from "./BaseMetricsSum.vue?vue&type=style&index=0&id=2ec4d266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec4d266",
  null
  
)

export default component.exports